export default __webpack_public_path__ + "static/tablet_KV02-59852072b142c6f2f86405697511e6e8.mp4";